import has from "lodash/has";

export interface ProdutoObject {
  id: string;
  sku: string;
  label: string;
  precos: {
    [regional: string]: number,
  }
}

export interface ProdutoVendido extends ProdutoObject {
  quantidade: number;
  valor?: number;
}

/*
Merge vendidos do banco de dados com dispoiveis atuais, atualizando labels
*/
export const mergeProdutosVendidos = (disponiveis: ProdutoObject[], vendidos: ProdutoVendido[]): ProdutoVendido[] => {
  const lkDisponiveis: any = {};
  disponiveis.forEach(i => {
    lkDisponiveis[i.sku] = i.label;
  })

  const merged: ProdutoVendido[] = [];
  vendidos.forEach(i => {
    if (has(lkDisponiveis, i.sku)) {
      merged.push({
        ...i,
        label: lkDisponiveis[i.sku],
      })
    } else {
      merged.push(i);
    }
  });

  return merged;
}
